// Mock data for Howick Podiatry website

export const clinicInfo = {
  name: 'Howick Podiatry',
  address: '3/10 Wellington Street, Howick',
  phone: '09 950 6801',
  email: 'info@howickpodiatry.co.nz',
  hours: {
    monday: '9am - 3pm',
    tuesday: '9am - 3pm',
    wednesday: 'Closed',
    thursday: '9am - 3pm',
    friday: 'Closed',
    saturday: 'Closed',
    sunday: 'Closed'
  },
  bookingUrl: 'https://howick-podiatry.au5.cliniko.com/bookings'
};

export const heroData = {
  title: 'Expert Care for Every Step',
  subtitle: 'Professional foot and ankle treatment in the heart of Howick',
  description: 'At Howick Podiatry, we provide expert, compassionate care for every step of your journey. From children to seniors, we deliver comprehensive foot health solutions tailored to your individual needs.',
  image: 'https://customer-assets.emergentagent.com/job_podiatry-howick/artifacts/uexp56ei_heidibheadshot_Original.jpg',
  ctaText: 'Book Your Appointment',
  ctaLink: '#booking'
};

export const services = [
{
  id: 1,
  title: 'Nail & Skin Care',
  description: "Professional, gentle treatment for ingrown toenails, fungal infections, corns, calluses, and general nail care to keep your feet healthy and comfortable.",
  icon: 'Scissors',
  image: 'https://customer-assets.emergentagent.com/job_podiatry-howick/artifacts/p6b606os_IMG_6850_Original.jpg',
  features: ['Ingrown toenail treatment', 'Fungal nail treatment', 'Corn & callus removal', 'General nail care']
},
{
  id: 2,
  title: 'Sports Injuries & Orthotics',
  description: "Specialised treatment for sports-related foot injuries, heel pain, flat feet, high arches. We create custom orthotic solutions to reduce pain, optimise your performance and prevent future injuries.",
  icon: 'Activity',
  image: 'https://customer-assets.emergentagent.com/job_podiatry-howick/artifacts/ghehij60_img_8595-4_Original.jpg',
  features: ['Sports injury treatment', 'Custom orthotics', 'Gait analysis', 'Biomechanical assessment']
},
{
  id: 3,
  title: "Children's Podiatry",
  description: 'Gentle, expert care for growing feet. We address common childhood foot conditions and ensure healthy development from first steps onwards.',
  icon: 'Heart',
  image: 'https://images.unsplash.com/photo-1595373298585-76fec7e55e00',
  features: ['Growing pains', 'Flat feet assessment', 'In-toeing/out-toeing', 'Wart treatment']
},
{
  id: 4,
  title: 'Diabetic Foot Care',
  description: 'Comprehensive diabetic foot assessments and ongoing care to prevent complications and maintain optimal foot health.',
  icon: 'ShieldCheck',
  image: 'https://images.unsplash.com/photo-1638202993928-7267aad84c31',
  features: ['Diabetic assessments', 'Wound care', 'Circulation checks', 'Neuropathy management']
},
{
  id: 5,
  title: 'Ingrown Toenail Treatment',
  description: 'Expert treatment for painful ingrown toenails, including conservative care and minor surgical procedures performed in-clinic.',
  icon: 'Zap',
  image: 'https://customer-assets.emergentagent.com/job_podiatry-howick/artifacts/p6b606os_IMG_6850_Original.jpg',
  features: ['Conservative treatment', 'Partial nail avulsion', 'Pain relief', 'Prevention advice']
}];


export const aboutData = {
  title: 'About Howick Podiatry',
  subtitle: 'Expert care for every step',
  description: "You'll find Howick Podiatry inside the Velca Health Clinic — and that's something we think makes a real difference for you. Being under the same roof as physiotherapists, chiropractors and other health professionals means we can work together on your care, share ideas, and make sure you're getting the best possible treatment from every angle. No running between clinics, no repeating your story — just joined-up care that helps you get back on your feet, faster.",
  mission: 'Our mission is to deliver expert care for every step — helping you maintain healthy, pain-free feet so you can stay active and enjoy life to the fullest.',
  podiatrist: {
    name: 'Heidi Barton',
    title: 'Principal Podiatrist',
    image: 'https://customer-assets.emergentagent.com/job_podiatry-howick/artifacts/uexp56ei_heidibheadshot_Original.jpg',
    bio: "Heidi graduated with a Bachelor of Health Science (Podiatry) in 2010 and has since built a career that spans nearly every corner of the profession — from community diabetes care and teaching clinical skills at AUT, to nine years running a private practice in Central and East Auckland. Most recently, she's been working in private practice and prior to that almost five years as a specialist podiatrist at Whakatāne Hospital.\n\nWith over 15 years of experience, Heidi's expertise covers everything from your toenails to your knees. Whether you're dealing with painful or fungal nails, stubborn arch and heel pain, or an Achilles injury that just won't shift, she brings both the clinical depth and the gentle touch to help you find lasting relief — from routine corn and callus care through to custom orthotics and ingrown toenail surgery.\n\nSince 2023, Heidi has also served as a podiatrist member of the Podiatrists Board of New Zealand, contributing to the governance of the profession alongside her clinical work.\n\nOutside the clinic, Heidi is a mum of two who has been steadily working through Auckland's 52 maunga with her family since hanging up her netball shoes in 2022.",
    qualifications: [
    'Bachelor of Health Science (Podiatry)',
    'Registered with Podiatry Board of New Zealand',
    'Member of Podiatry New Zealand',
    'ACC Registered Provider']

  }
};

export const faqData = [
{
  id: 1,
  question: 'Do I need a referral to see a podiatrist?',
  answer: 'No, you do not need a referral to see a podiatrist. You can book an appointment directly with us. However, if you have a referral from your GP, please bring it along as it may be helpful for your treatment.'
},
{
  id: 2,
  question: 'What should I bring to my first appointment?',
  answer: 'Please bring any relevant medical information, a list of current medications, and footwear you regularly wear (especially if you have concerns about shoes). If you have a referral letter or previous X-rays/scans, please bring those too.'
},
{
  id: 3,
  question: 'Does ACC cover podiatry treatment?',
  answer: 'Yes, we are ACC registered providers. If your foot condition is injury-related and covered by ACC, your treatment costs may be subsidised. We can help you with the ACC claim process during your appointment.'
},
{
  id: 4,
  question: 'How long is a typical appointment?',
  answer: 'Initial consultations typically take 45-60 minutes to allow time for a thorough assessment and treatment. Follow-up appointments are usually 30-45 minutes, depending on the treatment required.'
},
{
  id: 5,
  question: 'Do you treat children?',
  answer: 'Yes, we welcome patients of all ages, including children. We have experience treating a wide range of paediatric foot conditions and pride ourselves on making children feel comfortable during their visits.'
},
{
  id: 6,
  question: 'What is your cancellation policy?',
  answer: 'We require at least 24 hours notice for cancellations or rescheduling. This allows us to offer your appointment time to another patient. Late cancellations or no-shows may incur a cancellation fee.'
},
{
  id: 7,
  question: 'Do you make custom orthotics?',
  answer: 'Yes, we provide custom orthotic solutions tailored to your specific needs. After a thorough biomechanical assessment, we can create custom orthotics to help with various foot, ankle, knee, and lower back problems.'
},
{
  id: 8,
  question: 'Is parking available?',
  answer: 'Yes, there is convenient parking available near our clinic at 3/10 Wellington Street, Howick. Street parking is also available in the surrounding area.'
}];


export const contactData = {
  title: 'Get In Touch',
  subtitle: 'Ready to take the first step towards healthier feet?',
  description: 'Book your appointment today or contact us with any questions. We\'re here to help you achieve optimal foot health.',
  mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.8888888888888!2d174.9!3d-36.99!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDU5JzI0LjAiUyAxNzTCsDU0JzAwLjAiRQ!5e0!3m2!1sen!2snz!4v1234567890'
};